/** Keep MUI Autocomplete listboxes clickable above Dialog overlays. */
export const AUTOCOMPLETE_IN_DIALOG_PROPS = {
  slotProps: {
    popper: {
      disablePortal: true,
      sx: { zIndex: (theme) => theme.zIndex.modal + 1 },
    },
  },
}
